define('app/models/travel_search_hotel_model',['app/setup'], function(takhfifan) {
  takhfifan.travelSearchHotelModel = Backbone.Model.extend({
    defaults: {
      "person": 1
    },

    validation: {
      'cityId': {
        required: true,
        msg: i18n.t('cityId_missing')
      },
      'checkin': {
        required: false,
        msg: i18n.t('check_in_missing')
      },
      'checkout': {
        required: false,
        msg: i18n.t('check_out_missing')
      },
      'person': {
        required: false,
        msg: i18n.t('person_missing')
      }
    },
    
    setNights: function () {
      if(this.get('checkin') && this.get('checkout')){
        this.set('nights', Math.round((this.parseDate(this.get('checkout'))-this.parseDate(this.get('checkin')))/(1000*60*60*24)));
      }
    },

    parseDate: function(str) {
      var mdy = str.split('-');
      return new Date(mdy[0], parseInt(mdy[1],10)-1, parseInt(mdy[2],10));
    }
  });
});



